var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-content-mobileFull bg-bo-grey4 radius-18" },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-top gradient-bo-s2-90 flex-between-center radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close display-1 p-10 color-white",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.modal.dismiss()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "font-lato text-light",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("×")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-main" }, [
        _c("div", { staticClass: "imageCropper--preview mb-20" }, [
          _c(
            "div",
            {
              ref: "preview",
              staticClass: "preview text-center",
              staticStyle: { "max-width": "100%", overflow: "hidden" },
            },
            [
              _c("img", {
                style: { transform: "rotate(" + _vm.rotation + "deg)" },
                attrs: { src: _vm.image, alt: "preview" },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-center text-uppercase fsize-12 color-bo-s2 mb-20",
          },
          [_vm._v("Image Originale")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "imageCropper--edit pos-relative mb-50",
            staticStyle: { "max-width": "90%", margin: "auto" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "imageCropper--edit-actions fsize-26 flex-between-center p-10 pos-absolute zindex-1 color-white hover-bo-s2",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "iconBtn",
                    attrs: { title: "Rotation à droite" },
                    on: {
                      click: function ($event) {
                        return _vm.rotate(90)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fie-icon_flip" })]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex-center-center" }, [
              _c("div", [
                _c("img", {
                  ref: "image",
                  staticStyle: { "max-width": "100%" },
                  attrs: { id: "image", src: _vm.image, alt: "preview" },
                }),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-danger" }, [
          _vm._v(_vm._s(_vm.errorMsg)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "modal-bottom w-100 flex-between-center pos-sticky bottom-0 zindex-1 px-10 py-10",
        },
        [
          _c(
            "button",
            {
              staticClass: "inherit link-bo-grey1 fsize-14 mr-10",
              attrs: { type: "cancel" },
              on: {
                click: function ($event) {
                  return _vm.modal.dismiss()
                },
              },
            },
            [_vm._v("Annuler")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "inherit radius-5 bg-bo-s2 bg-hover-bo-s1 px-10 py-15 color-white text-uppercase text-sbold fsize-14",
              on: {
                click: function ($event) {
                  return _vm.returnCrop()
                },
              },
            },
            [
              _vm._v("\n\t\t\tValider "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving",
                  },
                ],
                staticClass: "fa fa-spinner fa-spin fa-lg",
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal-top--title color-white radius-18 radius-bottom-0" },
      [
        _c("div", { staticClass: "flex-start-center" }, [
          _c("i", { staticClass: "fie-icon_redim fsize-26" }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-15" }, [
            _c("div", { staticClass: "fsize-14 text-sbold" }, [
              _vm._v("Redimensionner l’image"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fsize-14" }, [_vm._v("Aperçu")]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }